import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=4343703c&scoped=true"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"
import style0 from "./matrix.vue?vue&type=style&index=0&id=4343703c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4343703c",
  null
  
)

export default component.exports